import request from '@/utils/request'

/**
 * 登录日志列表
 */
export const getLoginLogList = (data) => {
    return request({
        url: '/login/log/lists',
        params: data
    })
}

/**
 * 登录日志列表
 */
export const getOperationLogList = (data) => {
    return request({
        url: '/operation/log/lists',
        params: data
    })
}

/**
 * 短信日志列表
 */
export const getSMSLogList = (data) => {
    return request({
        url: '/sms/log/lists',
        params: data
    })
}

/**
 * 短信日志详情
 */
export const getMsgDetail = (id) => {
    return request({
        url: `/sms/log/${id}`
    })
}

/**
 * 获取命令执行日志列表
 */
export const getCmdLogList = (data) => {
    return request({
        url: '/cmd/log/lists',
        params: data
    })
}

/**
 * 获取命令日志详情
 */
export const getCmdDetail = (id) => {
    return request({
        url: `/cmd/log/${id}`
    })
}

/**
 * 获取含有设备详情的告警详情
 */
export const getBullyEventLogDetail = (id, data) => {
    return request({
        url: `/bully/event/log/data/${id}`,
        params: data
    })
}
